<template>
    <div style="padding-bottom: 10px; ">
        <div>
<!--            <van-cell-group>-->
<!--                <van-cell :title="title" style="padding-right: 0px">-->
<!--                    <h3 slot="title">{{title}}</h3>-->
<!--                    <template slot="right-icon">-->
<!--                        <Wp_date_select @onDateSelect="selectDateCount" :default="0"></Wp_date_select>-->
<!--                    </template>-->
<!--                </van-cell>-->
<!--            </van-cell-group>-->
            <Wp_time_pick_model date-format="yyyy-MM-dd"
                                :default-start="0"
                                :auto-search="true"
                                @pickTimes="pickTimes"
                                @search="clickToSearch">
            </Wp_time_pick_model>
        </div>

        <div style="margin-left: 10px; margin-top: 10px; font-size: 15px">
            预估收入合计 &nbsp;<span style="color: red;"> ¥ </span><span style="color: red; font-size: 20px; font-weight: bold">{{efeetodayall}}</span>
        </div>

        <van-divider style="border-color: #cccccc; margin: 10px 0px"/>

        <div style="margin: 0px 10px">
            <Wp_chart_line :pid="pid"
                           :start_time="startTime"
                           :end_time="endTime"
                           style="margin-top: 20px"
                           :incomeData="income_data"
            ></Wp_chart_line>
        </div>

        <div style="margin-top: 10px; padding: 10px 5px;box-shadow: 1px 1px 5px #999999;">
            <Wp_everyday_income_table :pid="pid"
                                      :start_time="startTime"
                                      :end_time="endTime"
                                      style="padding: 0px 10px"
                                      :table-data="table_data"
                                      :is-loading="isLoading"
            ></Wp_everyday_income_table>
        </div>

    </div>
</template>

<script>
    import Wp_everyday_income_table from "../../custom/Wp_everyday_income_table";
    import Wp_chart_line from "../../custom/Wp_chart_line";
    import Wp_time_pick_model from "../../custom/Wp_time_pick_model";
    export default {
        name: "Wp_order_count_detail_model",
        components: {Wp_time_pick_model, Wp_chart_line, Wp_everyday_income_table},
        props:{

        },

        data(){
            return{
                pid: "",
                title:'今日数据',
                startTime:this.$store.state.startTime,
                endTime:this.$store.state.endTime,
                efeetodayall: 0,
                income_data: [],
                table_data:[],
                isLoading: true,

                isSearching: false
            }
        },

        created(){
            this.pid = this.$common.getPid();
        },

        methods:{

            // setIncomeDatas(data){
            //     this.income_data = data;
            // },

            pickTimes(times){
                this.startTime = times.start_time;
                this.endTime = times.end_time;
            },

            clickToSearch(){
                if(this.isSearching){
                    this.$toast("数据查询中，请稍后...")
                }else{
                    this.isSearching = true;
                    this.getEverydayCountList();
                }

            },

            selectDateCount(selectDate) {
                this.$log(selectDate);
                this.startTime = selectDate.startTime;
                this.endTime = selectDate.endTime;
                this.showTitle();
                this.getEverydayCountList();
            },


            showTitle(){
                let testTime_1=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', 0, new Date()));
                let testTime_2=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', -1, new Date()));
                if(testTime_1===this.startTime && testTime_1===this.endTime){
                    this.title='今日数据'
                }else  if(testTime_2===this.startTime && testTime_2===this.endTime){
                    this.title='昨日数据'
                }else if(this.startTime===this.endTime){
                    this.title='数据('+this.startTime+')'
                }else{
                    this.title=this.startTime+' 至 '+this.endTime+' 数据'
                }
            },

            getEverydayCountList(){
                this.table_data = [];
                this.income_data = [];

                let params = {
                    uid: this.$store.state.username,
                    stime: this.startTime,
                    etime: this.endTime
                };

                this.$getEverydayCountList_tb(params, response=>{
                    this.$log(response)
                    if(response && response.code === 200){
                        this.isLoading = false;
                        this.isSearching = false;
                        let datas = response.data;
                        let _effee_temp = 0;
                        for(let i = 0; i < datas.length; i++){
                            this.table_data.push({
                                date: datas[i].day,
                                date_income: Number(datas[i].efeetodayall).toFixed(2) + " 元"
                            })
                            this.income_data.push({
                                date: datas[i].day,
                                date_income: Number(datas[i].efeetodayall).toFixed(2)
                            })

                            _effee_temp += Number(Number(datas[i].efeetodayall).toFixed(2));
                        }

                        this.efeetodayall = Number(_effee_temp).toFixed(2);

                        // this.$emit("setIncomeDatas", this.income_data);
                    }else if(response.toString().indexOf("Error: timeout") != -1){
                        this.$dialog.confirm({
                            message: "数据加载超时，请重试"
                        }).then(()=>{
                            this.getPidLevelCountList();
                        }).catch(()=>{
                            this.isLoading = false;
                            this.isSearching = false;
                        });
                    }

                })
            }
        }
    }
</script>

<style scoped>

</style>